import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { UiIconButton } from "@smp/ui";
import { useSnackbar } from "notistack";

import { IButtonCloseProps } from "./button_close.types";

export const ButtonClose = ({ id }: IButtonCloseProps) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <UiIconButton
      aria-label="Close notification"
      color="white"
      onClick={() => closeSnackbar(id)}
    >
      <CancelOutlinedIcon fontSize="small" />
    </UiIconButton>
  );
};
